import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllAccordionWorkflowComponent } from './accordion-workflow.component';
import { BllAccordionWorkflowPanelComponent } from './accordion-workflow-panel.component';
import { BllAccordionWorkflowHeaderComponent } from './accordion-workflow-header.component';
import { BllIconModule } from '../icon';

@NgModule({
  imports: [CommonModule, BllIconModule],
  declarations: [
    BllAccordionWorkflowComponent,
    BllAccordionWorkflowPanelComponent,
    BllAccordionWorkflowHeaderComponent,
  ],
  exports: [BllAccordionWorkflowComponent, BllAccordionWorkflowPanelComponent, BllAccordionWorkflowHeaderComponent],
})
export class BllAccordionWorkflowModule {}
